import { render, staticRenderFns } from "./UsersLogs.vue?vue&type=template&id=0ed5c130&scoped=true&"
import script from "./UsersLogs.vue?vue&type=script&lang=js&"
export * from "./UsersLogs.vue?vue&type=script&lang=js&"
import style0 from "./UsersLogs.vue?vue&type=style&index=0&id=0ed5c130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed5c130",
  null
  
)

export default component.exports